import { Component } from '@angular/core';
import { StorefrontComponent } from "@spartacus/storefront";

@Component({
  selector: 'kb-nyab-delivery-root',
  templateUrl: './app.component.html',
  imports: [StorefrontComponent]
})
export class AppComponent {
  title = 'kbnyabdelivery';
}
